import type { Drone, ServiceIntervalMap, ServiceLifeStatus } from '../../types';
import { getServiceLifeRemaining } from '../getServiceLifeRemaining';
import { getWorstWear } from '../getWorstWear';

type RingLabels = {
    motors: string;
    props: string;
    pumps: string;
};

export type HealthRing = { label: string; serviceLife: ServiceLifeStatus };

const FULL_LIFE_PERCENT = 100;

// Converts a worst-unit wear reading into remaining service-life (100 − wear).
const toServiceLife = (wearStatus: ReturnType<typeof getWorstWear>): ServiceLifeStatus => {
    if (!wearStatus.configured) {
        return { configured: false };
    }

    return {
        configured: true,
        remaining: Math.min(
            FULL_LIFE_PERCENT,
            Math.max(0, FULL_LIFE_PERCENT - wearStatus.percentage)
        )
    };
};

export const getHealthRings = ({
    drone,
    labels,
    serviceIntervals
}: {
    drone: Drone;
    labels: RingLabels;
    serviceIntervals: ServiceIntervalMap;
}): HealthRing[] => [
    {
        label: labels.motors,
        serviceLife: toServiceLife(
            getWorstWear({ interval: serviceIntervals.motor, units: drone.motors })
        )
    },
    {
        label: labels.props,
        serviceLife: getServiceLifeRemaining({
            interval: serviceIntervals.propSet,
            usage: drone.usage.propSet ?? 0
        })
    },
    {
        label: labels.pumps,
        serviceLife: toServiceLife(
            getWorstWear({ interval: serviceIntervals.pumpSealKit, units: drone.pumps })
        )
    }
];
